module.exports = __webpack_public_path__ + "img/gift-book.a68663e3.png";